// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3WUp_","question":"Question_question__1_Vva","description":"Question_description__Sdey6"};